export interface DailyReportStatus {
  value: string;
  label: string;
}

export interface DayInfo {
  year: number;
  dayOfYear: number;
  date: Date;
  dayName: string;
  isWeekend: boolean;
}

export interface DailyReportBulkRequest {
  report_date: string;
  user_ids: number[];
}

export interface DailyReportCell {
  user_id: number;
  hour_slot: number;
  cc_status: string;
  call_count: number;
}

/** Egyelőre csak a 2026-os év érhető el a napi riportban */
export const AVAILABLE_YEARS: number[] = [2026];

/** Ez előtt a nap előtt nem gyűjtöttünk órás bontású adatot */
export const DATA_START_DATE = '2026-07-31';

/** A táblázatban megjelenített órasávok kezdő órái (08:00-09:00 ... 16:00-17:00) */
export const HOUR_SLOTS: number[] = [8, 9, 10, 11, 12, 13, 14, 15, 16];

export const DAILY_REPORT_STATUSES: DailyReportStatus[] = [
  { value: 'hivando', label: 'Hívandó' },
  { value: 'visszahivando', label: 'Visszahívandó' },
  { value: 'elutasitott', label: 'Elutasított' },
  { value: 'robinson_listas', label: 'Robinson listás' },
  { value: 'nem_vette_fel', label: 'Nem vette fel' },
  { value: 'egyeztetett-kum', label: 'Egyeztetett (KÜM)' },
  { value: 'egyeztetett-vagyon', label: 'Egyeztetett (vagyon)' },
  { value: 'egyeztetett-kv', label: 'Egyeztetett (K+v)' }
];

export const DAY_NAMES_HU = ['Vasárnap', 'Hétfő', 'Kedd', 'Szerda', 'Csütörtök', 'Péntek', 'Szombat'];
